export default __webpack_public_path__ + "static/media/rainy-night.3bcd7b3f.jpg";